import { useState } from "react";

import { FormControl, Grid, MenuItem, Select } from "@mui/material";
import { useTranslation } from "react-i18next";

import { ReactComponent as ArrowDown } from "../../../Assets/Images/Icon/ArrowDownWithLine.svg";
import { ReactComponent as ArrowUp } from "../../../Assets/Images/Icon/ArrowUpWithLine.svg";
import { Text } from "../../atoms/Typography/Text/Text";

export const PostPerPage = ({ onPageSizeChange, pageSize }) => {
  const { t } = useTranslation();
  const handleChange = (event) => {
    let selectedPageSize = event.target.value;
    onPageSizeChange(selectedPageSize);
  };

  const [expand, setExpand] = useState(false);

  const handleOpen = () => {
    setExpand(true);
  };

  const handleClose = () => {
    setExpand(false);
  };
  const outlinedSelectors = [
    "& .MuiOutlinedInput-notchedOutline",
    "&:hover .MuiOutlinedInput-notchedOutline",
    "&.Mui-focused .MuiOutlinedInput-notchedOutline",
    "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline",
  ];
  return (
    <>
      <Grid container gap={"12px"}>
        <FormControl size="small" style={{}}>
          <Select
            defaultValue={pageSize || 10}
            value={pageSize}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            onClose={handleClose}
            onOpen={handleOpen}
            IconComponent={expand ? ArrowUp : ArrowDown}
            sx={{
              width: "72px",
              [outlinedSelectors.join(",")]: {
                border: "1.5px solid var(--SystemGray-03-Light, #C7C7CC)",
              },
              "& fieldset": {
                border: "none",
              },

              padding: "1px",
              borderRadius: "8px",
              border: "none",

              "& .MuiOutlinedInput-input": {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",

                width: "auto",
              },
              "& .MuiSelect-icon": {
                marginRight: "2px",
                top: "auto",
              },
              "& .MuiSelect-select": {
                marginRight: "7px",
                paddingLeft: "10px",
              },
              "& .MuiInputBase-root": {
                width: "65.73px",
              },
            }}
            onChange={handleChange}
          >
            <MenuItem value={10} style={{ height: "30px" }}>
              <p style={{ fontSize: "13px", color: "#37373A" }}>10</p>
            </MenuItem>
            <MenuItem value={25} style={{ height: "30px" }}>
              <p style={{ fontSize: "13px", color: "#37373A" }}>25</p>
            </MenuItem>
            <MenuItem value={50} style={{ height: "30px" }}>
              <p style={{ fontSize: "13px", color: "#37373A" }}>50</p>
            </MenuItem>
          </Select>
        </FormControl>
        <Text text={t("common:table-pagination.rows-per-page")} />
      </Grid>
    </>
  );
};
